/**********************/
/* User /me ACTIONS */
/**********************/
import * as actionTypes from "../actionTypes";
import axios from "../../../axios";
import { logout } from "./auth";
import {getAxiosHeader} from "../../../shared/utility";

// export const getLoggedInUserStart = () => {
//   return {
//     type: actionTypes.GET_USER_ME__START
//   };
// };
export const getLoggedInUserSuccess = (user) => {
  return {
    type: actionTypes.GET_USER_ME_SUCCESS,
    user: user
  }
};
export const getLoggedInUserFail = (error) => {
  return {
    type: actionTypes.GET_USER_ME_FAIL,
    error: error
  }
};

export const getLoggedInUser = (token) => {
  return dispatch => {
    //dispatch(getLoggedInUserStart());
    const headers = getAxiosHeader();
    axios.get('/users/me', headers)
      .then(response => {
        const user = response.data.data;
        //console.log('getLoggedInUser AXIOS response ', user);
        dispatch(getLoggedInUserSuccess(user));
      })
      .catch(err => {
        //console.log('getLoggedInUser AXIOS catch err ', err);
        dispatch(getLoggedInUserFail(err.response.status));
        dispatch(logout());
      });
  }
};